export default __webpack_public_path__ + "static/media/tooltip.bb2518e5.svg";